export enum IFrameId {
  broadcasts = 'BROADCAST',
  schedule = 'SCHEDULE',
  uploadcenter = 'FILE_UPLOAD',
  upload = 'FILE_UPLOAD',
  'file-management' = 'FILE_MANAGEMENT',
  waitlists = 'WAITLISTS',
  reports = 'REPORTS',
  'my-account' = 'MY_ACCOUNT',
  'main-account' = 'MAIN_ACCOUNT',
  'practice-resources' = 'PRACTICE_RESOURCES',
  'appointment-types' = 'PRACTICE_RESOURCES_APPT_TYPE',
  providers = 'PRACTICE_RESOURCES_PROVIDER',
  facilities = 'PRACTICE_RESOURCES_FACILITY',
  features = 'FEATURE_SETTINGS',
  utilities = 'UTILITIES',
  branding = 'UTILITIES_BRANDING',
  'custom-actions' = 'UTILITIES_CUSTOM_ACTIONS',
  'form-builder' = 'UTILITIES_FORM_BUILDER',
  'patient-billing' = 'UTILITIES_PATIENT_BILLING',
  'waiting-room' = 'SCHEDULE_WAITING_ROOM',
  ACTIVITY_FEED = 'ACTIVITY_FEED',
  hub = 'HUB',
  'messaging-activity' = 'MESSAGING_ACTIVITY',
  'settings/utilities/message-library/broadcast' = 'UTILITIES_MESSAGE_LIBRARY',
  'settings/utilities/message-library/chat' = 'UTILITIES_HUB_LIBRARY',
  'settings/utilities/message-templates/appointments' = 'UTILITIES_MESSAGE_TEMPLATES',
  'settings/utilities/message-templates/feedback' = 'UTILITIES_FEEDBACK_TEMPLATES',
  'settings/utilities/message-templates/offers' = 'UTILITIES_OFFER_TEMPLATES',
  'settings/utilities/message-templates/referrals' = 'UTILITIES_REFERRAL_TEMPLATES',
  'settings/utilities/message-templates/waitlists' = 'UTILITIES_WAITLIST_TEMPLATES',
  'settings/utilities/message-templates/other' = 'UTILITIES_OTHER_TEMPLATES',
  'settings/features/general' = 'FEATURE_SETTINGS_GENERAL',
  'settings/features/communication' = 'FEATURE_SETTINGS_COMMUNICATION',
  'settings/features/feedback' = 'FEATURE_SETTINGS_FEEDBACK',
  'settings/features/forms' = 'FEATURE_SETTINGS_FORMS',
  'settings/features/followup' = 'FEATURE_SETTINGS_FOLLOWUP',
  'settings/features/inbound-referral' = 'FEATURE_SETTINGS_INBOUND_REFERRAL',
  'settings/features/outbound-referral' = 'FEATURE_SETTINGS_OUTBOUND_REFERRAL',
  'settings/features/reminder' = 'FEATURE_SETTINGS_REMINDER',
  'settings/features/scheduler' = 'FEATURE_SETTINGS_SCHEDULER',
  'settings/features/waiting-room' = 'FEATURE_SETTINGS_WAITING_ROOM',
  'settings/features/waitlist' = 'FEATURE_SETTINGS_WAITLIST',
  'settings/features/insurance-verification' = 'FEATURE_SETTINGS_INSURANCE_VERIFICATION',
  'settings/utilities/branding/patient-form' = 'UTILITIES_BRANDING',
  referrals = 'INBOUND_REFERRALS',
  'outbound-referrals' = 'OUTBOUND_REFERRALS',
  'patients/edit' = 'PATIENT_EDIT',
  'patients/add' = 'PATIENT_ADD',
  PATIENTS_MERGE_DUPLICATES = 'PATIENTS_MERGE_DUPLICATES',
}

export interface MessageFormat {
  version: 'v1';
  messageType: 'heartbeat';
  screenId: IFrameId;
}
